var map = {
	"./slot-02.png": 5099,
	"./slot-03.png": 5224,
	"./slot-04.png": 7373,
	"./slot-05.png": 3507,
	"./slot-06.png": 4040,
	"./slot-07.png": 944,
	"./slot-08.png": 663,
	"./slot-09.png": 3110,
	"./slot-10.png": 2459,
	"./slot-11.png": 5514,
	"./slot-12.png": 1415,
	"./slot-13.png": 1459,
	"./slot-14.png": 676,
	"./slot-15.png": 9361,
	"./slot-16.png": 1780,
	"./slot-17.png": 9954,
	"./slot-18.png": 8883,
	"./slot-19.png": 664,
	"./slot-20.png": 2396,
	"./slot-21.png": 3999,
	"./slot-22.png": 2608,
	"./slot-23.png": 5569,
	"./slot-24.png": 415,
	"./slot-25.png": 2160,
	"./slot-26.png": 6788,
	"./slot-27.png": 6471,
	"./slot-28.png": 7331,
	"./slot-29.png": 29,
	"./slot-30.png": 3630,
	"./slot-31.png": 4562,
	"./slot-32.png": 5311,
	"./slot-33.png": 9315,
	"./slot-34.png": 3750,
	"./slot-35.png": 5271,
	"./slot-36.png": 8401,
	"./slot-37.png": 2337,
	"./slot-38.png": 5793,
	"./slot-39.png": 912,
	"./slot-40.png": 9521,
	"./slot-41.png": 3468,
	"./slot-42.png": 343,
	"./slot-43.png": 9693,
	"./slot-44.png": 9167,
	"./slot-45.png": 2842,
	"./slot-46.png": 9320,
	"./slot-47.png": 9749,
	"./slot-48.png": 6689,
	"./slot-49.png": 1212,
	"./slot-50.png": 1381,
	"./slot-51.png": 5787,
	"./slot-52.png": 579,
	"./slot-53.png": 2601,
	"./slot-54.png": 4519,
	"./slot-55.png": 9058,
	"./slot-56.png": 90,
	"./slot-57.png": 8583,
	"./slot-58.png": 1797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2929;